<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">{{ currentNews.date }}</p>
    <div class="content">
      <template v-for="(p, index) in paragraphs" :key="index">
        <!-- 文字内容 -->
        <div class="content-section">
          <div class="text-block">
            <p :class="{ 'link-paragraph': isLinkParagraph(p) }" v-html="highlightText(p)"></p>
          </div>
        </div>

        <!-- 在特定段落后插入图片 -->
        <div v-if="index === 2" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture1?.url">
          </div>
        </div>
        <div v-else-if="index === 5" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture2?.url">
          </div>
        </div>
        <div v-else-if="index === 8" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture3?.url">
          </div>
        </div>
        <div v-else-if="index === 11" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture4?.url">
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  return newsList.find((news: any) => news.id === 'tisco-cooperation') || {};
});

const paragraphs = computed(() => {
  return currentNews.value.content?.split('---') || [];
});

const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};

const isLinkParagraph = (text: string) => {
  const normalized = text.trimStart();
  return normalized.startsWith('链接：') || normalized.startsWith('链接:');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto; 
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  line-height: 1.8;
  margin-bottom: 10px;
  white-space: pre-wrap;
  text-align: justify;
}

.text-block p.link-paragraph {
  text-align: left;
  text-indent: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.text-block :deep(a) {
  color: #0066cc;
  text-decoration: underline;
  overflow-wrap: anywhere;
  word-break: break-all;
}

.text-block :deep(a:hover) {
  text-decoration-thickness: 2px;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
  max-width: 800px;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
  display: block;
  margin-top: 15px;
  font-size: 1.1em;
}
</style>
